import { render, staticRenderFns } from "./BackendOrderGenerationSingle.vue?vue&type=template&id=a65c4a4e&scoped=true&lang=pug"
import script from "./BackendOrderGenerationSingle.vue?vue&type=script&lang=js"
export * from "./BackendOrderGenerationSingle.vue?vue&type=script&lang=js"
import style0 from "./BackendOrderGenerationSingle.vue?vue&type=style&index=0&id=a65c4a4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65c4a4e",
  null
  
)

export default component.exports